<template>
    <fragment>
        <section class="flat-slider style1 clearfix">
            <div class="rev_slider_wrapper fullwidthbanner-container">
                <div id="rev-slider1" class="rev_slider fullwidthabanner">
                    <ul>
                        <!-- Slide 1 -->
                        <li data-transition="random">
                            <!-- Main Image -->
                            <img :src="getBannerImageUrl()" alt="" data-bgposition="center center" data-no-retina>
                            <div class="overlay"></div>

                            <!-- Layers -->
                        </li>
                    </ul>
                </div>
            </div>
            <div class="apply-admission">
                <div class="apply-admission-wrap type2 bd-type1">
                    <div class="apply-admission-inner">
                        <h2 class="title text-center">
                            <span>Password Reset Success</span>
                        </h2>
                        <div class="caption text-center">
                            Please check your email inbox for further instructions on how to reset your account
                            <br />
                            <br />
                            Be sure to check your SPAM folder if you do not receive a message within the next 10 minutes.
                        </div>
                    </div>
                </div>
            </div>
        </section><!-- flat-slider -->
    </fragment>
</template>
<style scoped>
    .apply-admission {
        position: absolute;
        top: 25%;
        margin: 0;
        left: 15%;
        width: 70%;
        z-index: 100;
    }

    .apply-admission-wrap {
        padding-top: 20px !important;
        padding-bottom: 20px !important;
    }

    .register-link {
        color: white;
        text-decoration: underline;
        font-size: 20px;
    }

    .not-valid {
        border-color: rgb(255, 95, 96);
        border-width: 3px;
    }

    .alert-danger {
        background-color: rgb(255, 95, 96);
        border-color: rgb(255, 95, 96);
        color: white;
    }
</style>
<script>
    export default {
        name: 'ForgotSuccess',
        components: {
        },
        data: function () {
            return {
           
            }
        },
        computed: {
            siteDesign() {
                return this.$store.getters.getSiteDesign;
            },
        },
        methods: { 
            getBannerImageUrl: function () { 
                if (this.siteDesign && this.siteDesign.homePage && this.siteDesign.homePage.bannerFileName) {
                    return `https://fabricfour.blob.core.windows.net/mhslearning-upload/${this.siteDesign.homePage.bannerFileName}`;
                }

                return "url('/wwwroot/images/home/header9.jpg')";
            },
        },
        mounted: function () {
            this.$store.commit("breadCrumbs", null);
        }
    };
</script>
